import { apiEndpoints } from "@/services/api/api";
import { CertificateResponse } from "../types/certificateResponse";

export interface CertificatesLoaderData {
  certificates: CertificateResponse[];
}

export const certificatesLoader = async (): Promise<CertificatesLoaderData> => {
  const response = await apiEndpoints.getMyCertificates();

  return {
    certificates: response.data || [],
  };
};
